import React from 'react';

interface MPSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  size?: 'sm' | 'md';
  id?: string;
}

const MPSwitch: React.FC<MPSwitchProps> = ({
  checked,
  onChange,
  label,
  disabled = false,
  size = 'md',
  id,
}) => {
  const trackSize = size === 'sm' ? { width: 36, height: 20, dot: 16, translate: 16 } : { width: 44, height: 24, dot: 20, translate: 20 };

  return (
    <label
      className={`inline-flex items-center gap-2 select-none ${disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer'}`}
      htmlFor={id}
    >
      <button
        id={id}
        role="switch"
        type="button"
        aria-checked={checked}
        disabled={disabled}
        onClick={() => !disabled && onChange(!checked)}
        style={{
          position: 'relative',
          width: trackSize.width,
          height: trackSize.height,
          borderRadius: trackSize.height,
          backgroundColor: checked ? '#FC7556' : 'var(--border-color)',
          border: 'none',
          padding: 0,
          cursor: disabled ? 'not-allowed' : 'pointer',
          transition: 'background-color 0.2s ease',
          flexShrink: 0,
        }}
      >
        <span
          style={{
            position: 'absolute',
            top: (trackSize.height - trackSize.dot) / 2,
            left: checked ? trackSize.translate : (trackSize.height - trackSize.dot) / 2,
            width: trackSize.dot,
            height: trackSize.dot,
            borderRadius: '50%',
            backgroundColor: '#ffffff',
            transition: 'left 0.2s ease',
            boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
          }}
        />
      </button>
      {label && (
        <span className="text-sm whitespace-nowrap" style={{ color: 'var(--text-color)' }}>
          {label}
        </span>
      )}
    </label>
  );
};

export default MPSwitch;
